/**
 * Hook useLocalizedPath
 * Devuelve una función que convierte una ruta interna a la del idioma actual
 * (según el prefijo de la URL). Útil para `navigate()` y enlaces manuales.
 */

import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { getLanguageFromPath, localizePath } from '../i18n/paths';

/**
 * @returns {(path: string) => string} Función `(path) => rutaLocalizada`
 */
const useLocalizedPath = () => {
  const { pathname } = useLocation();
  const language = getLanguageFromPath(pathname);
  return useCallback((path) => localizePath(path, language), [language]);
};

export default useLocalizedPath;
